/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import KeyValueDisplay from "../Common/KeyValueDisplay";
import { camelToTitleCase, checkIfUrl } from "../../utility";
import { CopyButton } from "../Common/CopyButton";
import PropTypes from "prop-types";

/**
 * This component is used to display attributes along with their copy button.
 * @param {Object} attribute The attribute to be displayed. Object needs to contain a string for name and value
 */
const AttributeDisplayListItem = ({ attribute }) => {
	var url = checkIfUrl(attribute.value);
	return (
		<span style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
			<div style={{ width: "100%", marginRight: 5 }}>
				<KeyValueDisplay
					label={camelToTitleCase(attribute.name)}
					node={
						url ? (
							<a href={attribute.value} target={"_blank"} rel="noopener noreferrer">
								{attribute.value}
							</a>
						) : (
							<span>{attribute.value}</span>
						)
					}
					row
				></KeyValueDisplay>
			</div>
			{attribute.value && <CopyButton value={attribute.value} />}
		</span>
	);
};

AttributeDisplayListItem.propTypes = {
	attribute: PropTypes.exact({
		id: PropTypes.string,
		name: PropTypes.string,
		order: PropTypes.number,
		value: PropTypes.string,
		prefix: PropTypes.string,
	}),
};

export default AttributeDisplayListItem;
